module.exports = __webpack_public_path__ + "img/58.3eb55a2a.png";